import React, {lazy, Suspense} from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';

import withClass from '../../../../hoc/withClass';
import Spinner from '../../../UI/Spinner/Spinner';
import General from './General/General';
import Password from './Password/Password';
import Notifications from './Notifications/Notifications';

const Placeholder = lazy(() => import('./Placeholder/Placeholder'));

const Main = props => {

    return (
        <Switch>
            <Route path='/settings/general' exact component={General} />
            <Route path='/settings/passwords' exact component={Password} />
            <Route path='/settings/notifications' exact component={Notifications} />
            <Route path='/settings' exact render={() => <Suspense fallback={<Spinner />}><Placeholder /></Suspense>} />
        </Switch>
    );
}

export default withRouter(withClass(Main, 'page-main'));
